
import Egg2x from "~images/sem/grade-selection/egg2x.png";
import Egg2xHover from "~images/sem/grade-selection/egg2x_hover.png";
import i18n from "../../../../app/js/utils/i18n";
import { getOrdinalCode } from "../../../../app/js/utils/web-helper";

export const getGrades = (grades) => {

  const gradesConfig =  [
    {
      name: `${i18n.t("sem.grade." + getOrdinalCode("pk"))}`,
      value: "pk",
      image: Egg2x,
      style: { top: "2rem" },
      hoverImage: Egg2xHover
    },

    {
      name: `${i18n.t("sem.grade." + getOrdinalCode("k"))}`,
      value: "k",
      image: Egg2x,
      rotate: -46.97,
      hoverImage: Egg2xHover
    },

    {
      name: `${i18n.t("sem.grade." + getOrdinalCode("1"))}`,
      value: "1",
      rotate: -27.97,
      image: Egg2x,
      hoverImage: Egg2xHover
    },

    {
      name: `${i18n.t("sem.grade." + getOrdinalCode("2"))}`,
      value: "2",
      rotate: -79.98,
      image: Egg2x,
      style: { top: "2rem" },
      hoverImage: Egg2xHover

    },

    {
      name: `${i18n.t("sem.grade." + getOrdinalCode("3"))}`,
      value: "3",
      image: Egg2x,
      style: { top: "2rem", left: "2.5rem" },
      hoverImage: Egg2xHover

    },

    {
      name: `${i18n.t("sem.grade." + getOrdinalCode("4"))}`,
      value: "4",
      image: Egg2x,
      rotate: 120,
      style: { top: ".2rem" },
      hoverImage: Egg2xHover
    },

    {
      name: `${i18n.t("sem.grade." + getOrdinalCode("5"))}`,
      value: "5",
      rotate: 44.03,
      image: Egg2x,
      style: { top: "2rem", right: "2.5rem" },
      hoverImage: Egg2xHover
    }
  ]

  if(grades && grades.length){
    if(!Array.isArray(grades))
      grades = grades.split(",");
    return gradesConfig.filter(item => grades.includes(item.value))
  }

  return gradesConfig;
}